document.addEventListener('DOMContentLoaded', function () {

		document.querySelectorAll('.wens-post-tabs-wrapper').forEach(function (wrapper) {

			const buttons = wrapper.querySelectorAll('.post-tab-btn');
			const panels  = wrapper.querySelectorAll('.post-tab-panel');

			buttons.forEach(function (btn) {

				btn.addEventListener('click', function () {

					const tabId = this.dataset.tab;

					buttons.forEach(b => b.classList.remove('active'));
					panels.forEach(p => p.classList.remove('active'));

					this.classList.add('active');

					const target = wrapper.querySelector(
						`.post-tab-panel[data-content="${tabId}"]`
					);

					if ( target ) {
						target.classList.add('active');
					}

				});

			});

		});

	});
